import { request } from "../../apis";
import { NewsDetailParams } from "./data";

export const apiGetNewsList = (params: any): any =>
  request("get", `/api/article/list`, params, true);

export const apiGetNewsCategory = (): any =>
  request("get", `/api/article/category/list`, null, true);

export const apiGetNewsDetail = (params: NewsDetailParams): any =>
  request("get", `/api/article/detail/${params.id}`, params, true);
